import { mapFirstImage } from '../DataTypes/imageMapper';
import { mapFirstLink } from '../DataTypes/linkMapper';
import logger from '3-foundation/Logging/logger';

interface Props {
	content: {
		contentType: 'organisationList';
		properties: {
			heading: string;
			link: Umbraco.Link[];
			organisations: Umbraco.Organisation[];
		};
	};
}

export const mapOrganisationList = ({ content }: Props): Content.OrganisationList => {
	const { heading, link, organisations } = content?.properties ?? {};
	try {
		return {
			documentType: content?.contentType,
			content: {
				heading,
				link: mapFirstLink(link),
				organisations: organisations?.map((organisation) => {
					const { logo, organisationPageLink, address, description, email, openingHours, phone } = organisation?.properties ?? {};
					const { name: linkName, route } = organisationPageLink?.[0] ?? {};
					return {
						address: address?.markup,
						description: description?.markup || null,
						email,
						logo: mapFirstImage(logo),
						name: organisation?.name,
						openingHours: openingHours?.markup || null,
						organisationPageLink: route ? { url: route.path, name: linkName } : null,
						phone,
					};
				}),
			},
		};
	} catch (e) {
		logger.error('Could not map Organisation List', e);
		throw new Error('Could not map Organisation List', e);
	}
};
